import { Locale } from 'modules/domains/template';
import {
  EmailContentDefinition,
  GRAPHQL_TYPENAMES,
  MediumContent,
  MessageMedium,
  PushContentDefinition,
  SMSContentDefinition,
} from 'modules/graphql';
import {
  SelectedMessageMedium,
  TemplateAndContentFormDataLocale,
} from 'modules/templateEditor/common';
import { TemplateWithMessageMediumLabels } from 'modules/templateIndex';
import { ContentModalStateType, CopyTemplateModalType } from 'utils/contexts/modal';

export const getLocalesToCopy = (activeTemplateLocales: Locale[] = []) =>
  activeTemplateLocales.map((locale) => ({ id: locale.tag }));

/** Get content preview value for copy modal, is different depending on the medium */
export const getContentPreview = (
  medium: SelectedMessageMedium,
  mediumData: MediumContent,
): string => {
  switch (medium) {
    case MessageMedium.Email: {
      return (mediumData as EmailContentDefinition).html;
    }
    case MessageMedium.SMS: {
      return (mediumData as SMSContentDefinition).message || '';
    }
    case MessageMedium.Push: {
      return (mediumData as PushContentDefinition).message || '';
    }
    default:
      return '';
  }
};

export const getCopyModalTemplateFormat = (
  messageMedium: SelectedMessageMedium,
  liveTemplate: TemplateAndContentFormDataLocale,
  mediumData: MediumContent,
  localesToCopy: {
    id: string;
  }[],
): TemplateWithMessageMediumLabels => {
  const { createdAt, creatorUser, templateId, name, updatedAt, updatedByUser } = liveTemplate;
  return {
    contentPreview: getContentPreview(messageMedium, mediumData),
    createdAt: createdAt || '',
    createdByUserId: creatorUser.id,
    creatorUser: {
      ...creatorUser,
      avatarUrl: creatorUser.avatarUrl || null,
      __typename: GRAPHQL_TYPENAMES.USER,
    },
    id: templateId,
    messageMedium,
    name,
    locales: localesToCopy,
    updatedAt: updatedAt || '',
    updatedByUserId: updatedByUser.id,
    updatedByUser: {
      ...updatedByUser,
      avatarUrl: updatedByUser.avatarUrl || null,
      __typename: GRAPHQL_TYPENAMES.USER,
    },
    __typename: GRAPHQL_TYPENAMES.TEMPLATE,
  };
};

export const getIsCopyTemplateModalVisible = (
  modalState: ContentModalStateType | null,
): modalState is CopyTemplateModalType =>
  !!modalState && 'showCopyModal' in modalState && !!modalState.showCopyModal.length;
